export class Suggest {
  shouldShow: boolean = false;
  title: string = 'キーワード候補';
  keyWordArray: string[] = [];

  constructor(apiReslut: Document) {
      const wordElements = apiReslut.getElementsByTagName('word');
      this.keyWordArray = Array.prototype.map.call(wordElements, el => el.textContent);
      this.shouldShow = (0 < this.keyWordArray.length);
  }
}
